import { render, staticRenderFns } from "./FooterWAP.vue?vue&type=template&id=c35ba976&scoped=true"
import script from "./FooterWAP.vue?vue&type=script&lang=js"
export * from "./FooterWAP.vue?vue&type=script&lang=js"
import style0 from "./FooterWAP.vue?vue&type=style&index=0&id=c35ba976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ba976",
  null
  
)

export default component.exports